export default __webpack_public_path__ + "static/about-us-security1-42a612d71554f35dd42a1e737d9d86a1.webp";